<div class="ep_card">
  <div class="ep_card-header ep_card-header-icon" [ngClass]="type">
    <div class="ep_card-icon">
      <i class="material-icons">{{ icon }}</i>
    </div>
    <p class="ep_card-category">{{ title }}</p>
    <h3 class="ep_card-title">{{ description }}</h3>
  </div>

  <div class="ep_card-footer">
    <div class="container-fluid">
      <div class="row">

        <!-- COLONNA SINISTRA -->
        <div class="col-2">

          <!-- PDF -->
          <h3>Proposte speciali</h3>

          <app-pdf-uploader
            title="PDF *"
            [pdferror]="pdffilename"
            [loading]="loadingScheda"
            (changeFile)="setPdf($event)"
            [pdf]="pdf"
            (download)="downloadPdf()"
          ></app-pdf-uploader>

          <p class="text">
            Puoi aggiungere un file pdf per indicare le tue proposte speciali di questo giro
          </p>

          <button
             mat-stroked-button
            color="primary"
            class="full-width uppercase mt-2"
            (click)="saveAllegatoPromozionale()"
          >
          <mat-icon>edit</mat-icon>
            Salva PDF
          </button>

         

        </div>

        <!-- COLONNA DESTRA -->
        <div class="col-10">

          <!-- INFO -->
          <div class="row">
            <div class="col-6">
              <mat-form-field class="full-width">
                <mat-label>Inizio prenotazioni</mat-label>
                <input
                  type="text"
                  [value]="inizioPren | formatDate"
                  matInput
                  disabled
                />
              </mat-form-field>
            </div>

            <div class="col-6">
              <mat-form-field class="full-width">
                <mat-label>Fine prenotazioni</mat-label>
                <input
                  type="text"
                  [value]="finePren | formatDate"
                  matInput
                  disabled
                />
              </mat-form-field>
            </div>

            <div class="col-6">
              <mat-form-field class="full-width">
                <mat-label>Mesi consigliati di uscita</mat-label>
                <input
                  type="text"
                  [value]="mesiConsigiati"
                  matInput
                  disabled
                />
              </mat-form-field>
            </div>

            <div class="col-6">
              <mat-form-field class="full-width">
                <mat-label>Volumi in distribuzione dal</mat-label>
                <input
                  type="text"
                  [value]="volumiInDistrDal | formatDate"
                  matInput
                  disabled
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
             <!-- NOVITA -->
              <div class="col-6">
<button
            mat-stroked-button
            color="accent"
            class="full-width uppercase mt-2"
            (click)="clickNovita()"
            matTooltip="Inserisci il materiale promozionale di una novità."
            style="height:100px"
          >
            <mat-icon>add_circle</mat-icon>
            Aggiungi novità
          </button>
              </div>
          <div class="col-6"> <!-- RISTAMPA -->
          <button
            style="height:100px"
            mat-stroked-button
            color="primary"
            class="full-width uppercase mt-2"
            (click)="clickRistampa()"
            matTooltip="Inserisci il materiale promozionale di una ristampa."
          >
            <mat-icon>add_circle</mat-icon>
            Aggiungi ristampa
          </button> </div>
 
          </div>
          <br>
          <div class="row">
            <div class="col-4">
                  <!-- SELECT GIRO -->
          <mat-form-field class="giro-select">
            <mat-label>Seleziona Giro</mat-label>
            <mat-select
              (selectionChange)="getNovitaGiro($event)"
              [(value)]="giroResumeSelected"
            >
              <mat-option
                *ngFor="let giro of giriResume"
                [value]="giro.cod"
              >
                {{ giro.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          </div>
          </div>
          <div class="row">
            <div class="col-12">
                <!-- TABELLA -->
                  
         <app-tabella
            [data]="titoliGiro"
            [loading]="loading"
            title="Resoconto del giro"
            [subtitle]="subtitle"
            icon="grid_on"
            type="ep_card-header-primary"
            style="width: 100%"
          ></app-tabella>  
            </div>
          </div>

         

        </div>
      </div>
    </div>
  </div>
</div>